import { HttpHeaders } from '@angular/common/http'
import { Injectable, computed, signal } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class RateLimitService {
  readonly limit = signal(Infinity)
  readonly remaining = signal(Infinity)
  readonly resetAt = signal(0)

  readonly isLow = computed(() => this.remaining() <= 5)
  readonly isExhausted = computed(() => this.remaining() <= 0)

  update(headers: HttpHeaders): void {
    const limit = headers.get('x-ratelimit-limit')
    const remaining = headers.get('x-ratelimit-remaining')
    const reset = headers.get('x-ratelimit-reset')

    if (limit != null) this.limit.set(+limit)
    if (remaining != null) this.remaining.set(+remaining)
    if (reset != null) this.resetAt.set(Date.now() + +reset * 1000)
  }

  msUntilReset(): number {
    return Math.max(0, this.resetAt() - Date.now())
  }
}
